import React from 'react';
import { Disc3 } from 'lucide-react';

export const TireServicesBanner = ({ testId }) => (
  <aside className="tire-banner" data-testid={testId}>
    <Disc3 size={38} aria-hidden="true" />
    <div><span className="eyebrow">Desert Meadows only</span><h4>Full Tire Services Available</h4><p>Tire Sales · Tire Balancing · Expert Installation</p></div>
  </aside>
);